module.exports = __webpack_public_path__ + "img/iso1328-1-2013_fig15_helix-excess.6c36d069.png";